module.exports = __webpack_public_path__ + "assets/img/benefit-4.a822add0.svg";